module.exports = __webpack_public_path__ + "media/images/area/area_kagawaM400-85dd300661dd3441a4367a368df2e0cf.jpg";